import script from "./CompetitionSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionSingle.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionSingle.vue?vue&type=style&index=0&id=2e21ccd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e21ccd2"]])

export default __exports__